import {useLocation} from "react-router-dom";
import Grid from "@mui/material/Grid";
import React from "react";
import JobsAdd from "./JobAdd";

export default function JobEdit() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const jobID = searchParams.get('jobID');

    if (jobID) {
        return <JobsAdd jobId={jobID} readOnly={false}/>
    }

    return (
        <Grid item>
            <h5 data-testid={"noJobProvided"} className={"gridPadding"}>No job provided</h5>
        </Grid>
    )

}